import { render, staticRenderFns } from "./order-tabs.vue?vue&type=template&id=3f83a990"
import script from "./order-tabs.vue?vue&type=script&lang=js"
export * from "./order-tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports